import { DataManager, UrlAdaptor } from '@syncfusion/ej2-data';
import { ComboBox } from '@syncfusion/ej2-dropdowns';

import { routes } from '@/shared/routes';

document.addEventListener('DOMContentLoaded', () => {
  [...document.querySelectorAll('.account-picker')]
    .map((element) => element as HTMLSpanElement)
    .forEach((element) => {
      const input = element.querySelector('input');
      const form = input?.form;

      if (input && form) {
        const accountPicker = new ComboBox({
          dataSource: new DataManager({
            url: routes.data.lookup.list({ model: 'Account' }),
            adaptor: new UrlAdaptor(),
          }),
          fields: {
            value: 'value',
            text: 'text',
          },
          placeholder: 'Select account',
          sortOrder: 'Ascending',
          value: input.dataset.value ?? undefined,
          allowCustom: false,
          allowFiltering: true,
          change: () => form.submit(),
        });

        accountPicker.appendTo(input);
      }
    });
});
